import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import BusinessTypeApi from '../../Api/BusinessType';
import { Icon } from '@iconify/react/dist/iconify.js';
import Swal from "sweetalert2";

const BusinessType = () => {

    const [businessTypeId, setBusinessTypeId] = useState();
    const [businessName, setBusinessName] = useState();


    useEffect(() => {
        console.log("businessName", businessName);
    }, [businessName]);

    const handleSave = async () => {
        const response = await BusinessTypeApi.CreateBusinessType(businessName)
        if (response) {
            console.log("success", response)
            fetchData()
        }
    }

    const handleUpdate = async () => {
        const response = await BusinessTypeApi.UpdateBusinessType(businessTypeId, businessName)
        if (response) {
            console.log("success", response)
            fetchData()
        }
        setBusinessTypeId(null)
        setBusinessName("")
    }

    const [data, setData] = useState([]);

    const handleEdit = (item) => {
        console.log("item", item);
        setBusinessTypeId(item.id)
        setBusinessName(item.businessName)
        console.log(`Edit item with id ${item.id}`);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this business type?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;

        const response = await BusinessTypeApi.DeleteBusinessType(id)
        if (response.StatusCode === 200) {
            Swal.fire({ title: "Deleted", text: "Deleted Successfully", icon: "success", width: "320px" })
            fetchData()
        }

        setData(prev => prev.filter(item => item.id !== id));
    };


    const fetchData = async () => {
        const response = await BusinessTypeApi.GetAllBusinessType();
        if (response) {
            console.log("response", response);
            setData(response.Result)
        }
    }

    useEffect(() => {
        fetchData()
    }, []);


    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Business Type</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_info-text-im depart_top">Report Template Setting</div> */}
                    <div className="company_control">
                        {/* <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Id</label>
                                </div>
                            </div>
                        </div> */}
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" value={businessName} required onChange={(e) => setBusinessName(e.target.value)} />
                                    <label class="modify_p_text2">Business Name</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ButtonTabSave">


                        {
                            businessTypeId ? (
                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }




                    </div>

                    <div className="company_info-text-im depart_top">Business Type List</div>
                    <div className="control_radius">
                        <div className="table-account-manager">
                            <table className='table-master-acc'>
                                <thead className='header-table-account'>
                                    <tr>
                                        <th className='table-header-manager ac-sno-wth'>S.No</th>
                                        <th className='table-header-manager'>Id</th>
                                        <th className='table-header-manager'>Business Name</th>
                                        <th className='table-header-manager'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                            <td className='table-data-account'>{item.id}</td>
                                            <td className='table-data-account'>{item.businessName}</td>
                                            <td className='table-data-account'>
                                                <button className="edit-btn-acc" onClick={() => handleEdit(item)}><Icon icon="lucide:edit" /></button>
                                                <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default BusinessType;
